// extracted by mini-css-extract-plugin
module.exports = {"center":"Introduction_center__3aEfg","button":"Introduction_button__U6rds","steps":"Introduction_steps__3WjXP","description":"Introduction_description__18tIy"};